import React from 'react';
import { Card, Statistic } from 'antd';
import type { StatisticProps } from 'antd';

interface HrStatCardProps extends StatisticProps {
  loading?: boolean;
}

const HrStatCard: React.FC<HrStatCardProps> = ({ loading, ...props }) => (
  <Card loading={loading} className="h-full">
    <Statistic {...props} />
  </Card>
);

export default HrStatCard;
